import React, { Component, Fragment } from 'react';
import { Route, Routes } from 'react-router';
import  Login  from './Login'
import { Logout } from './Logout'
import { ApplicationPaths, LoginActions, LogoutActions } from './ApiAuthorizationConstants';

export default class ApiAuthorizationRoutes extends Component {

  render () {
      return (
          <Routes>
              <Route path={ApplicationPaths.Login} element={<LoginAction name={LoginActions.Login} />} />
              <Route path={ApplicationPaths.LoginFailed} element={<LoginAction name={LoginActions.LoginFailed} />} />
              <Route path={ApplicationPaths.LoginCallback} element={<LoginAction name={LoginActions.LoginCallback} />} />
              <Route path={ApplicationPaths.Profile} element={<LoginAction name={LoginActions.Profile} />} />
              {/*<Route path={ApplicationPaths.Register} element={<LoginAction name={LoginActions.Register} />} />*/}
              <Route path={ApplicationPaths.LogOut} element={<LogoutAction name={LogoutActions.Logout} />} />
              <Route path={ApplicationPaths.LogOutCallback} element={<LogoutAction name={LogoutActions.LogoutCallback} />} />
              <Route path={ApplicationPaths.LoggedOut} element={<LogoutAction name={LogoutActions.LoggedOut} />} />
          </Routes>

      );
  }
}

function LoginAction({ name }){
    return (<Login action={name}></Login>);
}

function LogoutAction({ name }) {
    return (<Logout action={name}></Logout>);
}
